<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        :items="sortedContracts"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="false"
                        headlineKey="description"
                        v-model="selectedContractID"
                        filterLabel="Filter Contracts"
                >
                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createContractShow = !createContractShow"
                        >
                            <v-icon left>mdi-file-sign</v-icon>
                            Add Contract
                        </v-btn>
                    </div>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedContract">
                <v-card>
                    <ModifyContract :edit-contract="selectedContract" @save="upsertContract($event)"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createContractShow && createContractObj"
                    v-model="createContractShow"
                    :width="400"
                    persistent
            >
                <v-card>
                    <ModifyContract :edit-contract="createContractObj" @dismiss="createContractShow = !createContractShow" @save="upsertContract($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyContract from "./ModifyContract";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";

export default {
    components: {Divider, ModifyContract, MultiSelectList},
    props: {},
    data() {
        return {
            selectedContractID: null,
            createContractObj: null,
            createContractShow: false,
        }
    },
    watch: {
        createContractShow(val) {
            if (val)
                this.createContractObj = {
                    id: null,
                    description: null,
                    content: [],
                    fkContractDoc: null
                }
        }
    },
    methods: {
        async upsertContract(event) {
            let {contract, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/contract`, contract)
                const addedContractID = (await waitForEvent(eventID)).contracts.pop().id
                this.createContractShow = false
                this.selectedContractID = addedContractID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }

    },
    computed: {
        ...mapGetters(['contracts', 'contractsRef']),
        sortedContracts() {
            return [...this.contracts].sort((a,b) => a.decription > b.description ? 1 : -1)
        },
        selectedContract() {
            if (!this.selectedContractID)
                return null
            console.log(this.contracts, this.selectedContractID, this.contracts.find(obj => obj.id === this.selectedContractID))
            return this.contracts.find(obj => obj.id === this.selectedContractID)
        }
    },
}
</script>

<style scoped>

</style>